import { useRunOnce } from '@sparklayer-io/spark-dash-ui/hooks/use-run-once';
import { LoadingScreen } from '../../../components/loading-screen';
import type { DashboardPageProps } from '../../../lib/dashboard-page';

export function SwitchAccountPage({ handlers }: DashboardPageProps) {
  const { navigationHandler, authHandler } = handlers;

  useRunOnce(async () => {
    const teamId = navigationHandler.params().teamId ?? '';
    const isNewTeam = 'new-team' in navigationHandler.query();

    await authHandler.changeSite(teamId);

    navigationHandler.navigate(isNewTeam ? '/integrations/platform' : '/', {
      excludeSiteId: true,
      excludeSiteEnv: true,
    });
  });

  return <LoadingScreen />;
}
